import "./pages_css/Home.css";

function Home(props) {
  return < div id="homeContainer" >
  <h1 className="homeTitle">
  Christopher Bowman </h1> 
  <div className="homeTitleSmall">
      <li className="animation"> Mechanical Engineer </li>
      <li className="animation"> Structural Engineer </li>
      <li className="animation"> FEA and Software </li>
      <li className="animation"> Mechanical Engineer </li>
  </div>
  </ div >
}

export default Home;


